/** Crowdex's crow, traced from its app icon, in the current text color. */
export function CrowdexMark({ className, label }: { className?: string; label?: string }) {
  return (
    <svg
      aria-hidden={label === undefined || undefined}
      aria-label={label}
      className={className}
      fill="currentColor"
      role={label === undefined ? undefined : 'img'}
      viewBox="0 0 326 238"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2437 2321 c-136 -45 -194 -107 -344 -369 -76 -131 -82 -138 -238 -287 -279 -265 -508 -476 -585 -537 -70 -57 -211 -211 -328 -360 -29 -37 -65 -78 -81 -90 -45 -38 -316 -172 -441 -218 -122 -45 -158 -65 -102 -58 88 12 10 -35 -188 -114 -130 -51 -107 -66 42 -27 52 13 84 17 91 10 11 -11 -18 -27 -129 -71 -94 -38 -111 -50 -65 -50 27 0 32 -3 27 -16 -7 -18 -12 -18 106 2 51 9 48 -7 -4 -33 -86 -43 47 -17 234 45 82 28 92 29 89 10 -3 -19 40 -3 177 68 99 51 160 76 187 78 22 1 94 26 160 55 172 75 311 121 366 121 68 0 168 -34 211 -72 53 -47 209 -239 205 -252 -2 -6 -44 -13 -98 -16 -88 -5 -82 -5 81 -12 158 -7 177 -9 191 -27 10 -12 35 -23 60 -27 24 -4 55 -14 69 -23 25 -15 25 -15 8 5 -21 24 -23 44 -5 45 6 1 2 4 -9 7 -24 8 -274 229 -274 243 0 5 14 24 30 43 27 30 40 36 103 46 224 36 316 80 402 195 29 38 100 132 158 209 152 199 203 312 251 550 39 194 51 312 37 388 -16 96 -14 141 9 171 31 39 115 75 203 86 79 11 177 46 177 63 0 14 -81 45 -182 69 -171 40 -194 48 -224 81 -72 77 -253 110 -377 69z m330 -137 c8 -23 -14 -34 -69 -34 -52 0 -71 16 -43 37 27 19 104 17 112 -3z M1848 78 c35 -6 68 -6 72 -2 5 5 -23 10 -63 10 l-72 1 63 -9z"
        transform="translate(0 238) scale(0.1 -0.1)"
      />
    </svg>
  );
}
